/**
 * @file: This file tells whether an interval loses only to its own playlist,
 * and it gives the sentences for that case.
 *
 * The screen then shows that playlist anyway, so the interval adds nothing.
 * The Preflight card and the panel both report this case. The two must make
 * the same decision and use the same words, so the rule is in one file.
 */

/**
 * Tell whether every interval that covers an interval has the playlist of
 * that interval. The function compares the ids, because two playlists can
 * have the same name.
 *
 * @param {Array} coveredByPlaylistIds - The playlist ids of the covering intervals
 * @param {number|string} playlistId - The playlist id of the covered interval
 * @returns {boolean} False when no interval covers it
 */
export function coveredByOwnPlaylist (coveredByPlaylistIds, playlistId) {
  const ids = coveredByPlaylistIds || []

  return ids.length > 0 && ids.every(id => Number(id) === Number(playlistId))
}

/**
 * Give the cause and the repair for an interval that only its own playlist
 * covers.
 *
 * @param {string} playlist - The name of the playlist
 * @returns {Object} { cause, remedy }
 */
export function ownPlaylistCoverSentences (playlist) {
  return {
    cause: `Another interval of ${playlist} covers it for its whole duration. ` +
      `The screen shows ${playlist} anyway, so this interval adds nothing.`,
    remedy: `Delete this interval, or move it to a time that ${playlist} does not cover.`
  }
}
